<template>

	<dialog-slot
			:title="getTitle"
			@updateClose="onClose"
			@updateSave="onClose"
			width="800px"
			is-cancel-hide
			apply-text="Close"
	>
		<div class="updateInfo">
			<div class="updateInfo_text">
				<div class="updateInfo_text-title">Adds new features such as:</div>
				<span v-html="version.msg"></span>
			</div>
		</div>

		<template v-slot:subTitleFooter>
			<div v-if="versionShow" class="checkbox">
				<v-checkbox
						dense
						v-model="isCheckbox"
						label="Don't open popup until the next update"
				></v-checkbox>
			</div>
		</template>
	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "UpdateInfoPopup",
	components: {
		DialogSlot,
	},
	props: {
		version: Object,
		versionShow: Boolean
	},
	computed: {
		getTitle() {
			return `Update v.${ this.version.version }`;
		}
	},
	data: () => ({
		dialog: true,
		isCheckbox: false,
	}),
	methods: {
		onClose() {
			this.$emit('updateInfo', this.isCheckbox);
		}
	}
};
</script>

<style scoped lang="scss">
.updateInfoWrapper {
    .updateInfo {
        background: var(--card-bg);
        padding: 20px;
        
        .actionHeader {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            line-height: 24px;
            letter-spacing: 0.25px;
            color: var(--card-color);
            margin-bottom: 20px;
        }
        &_text {
            margin-bottom: 20px;
            font-size: 14px;
            
            &-title {
                font-size: 18px;
                margin-bottom: 10px;
            }
        }
    }
}

[type="button"] {
    line-height: 0;
}
</style>
<style lang="scss">
.updateInfoWrapper {
	.updateInfo {
		&_text {
			* {
				background-color: transparent !important;
				background: transparent !important;
			}
		}
	}
}
</style>
